import { trackByIndex } from 'src/app/shared/utils/track-by.util';
import { ChangeDetectionStrategy, Component, Input, OnInit, OnChanges, SimpleChanges } from '@angular/core';

import { TranslateService } from '../../../../services/translate.service';
import {
    RiskRegisterMatrixData,
    RiskRegisterMatrixPresentation,
    RiskRegisterTablePresentationService,
    RR_STYLES
} from './risk-register-table-presentation.service';

@Component({
    standalone: true,
    selector: 'app-risk-register-table-widget',
    imports: [],
    templateUrl: './risk-register-table-widget.component.html',
    styleUrl: './risk-register-table-widget.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class RiskRegisterTableWidgetComponent implements OnInit, OnChanges {
    @Input() data: RiskRegisterMatrixData | null = null;

    presentation: RiskRegisterMatrixPresentation | null = null;
    noDataLabel = '';
    readonly styles = RR_STYLES;

    constructor(
        private translateService: TranslateService,
        private presentationService: RiskRegisterTablePresentationService
    ) { }

    ngOnInit(): void {
        this.noDataLabel = this.translateService.getDynamicTranslation('No Data Available');
        this.processData();
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['data']) this.processData();
    }

    private processData(): void {
        this.presentation = this.presentationService.build(this.data, {
            segCode: this.translateService.getDynamicTranslation('SEG Code'),
            segName: this.translateService.getDynamicTranslation('SEG Name'),
            workers: this.translateService.getDynamicTranslation('No of Employees'),
            contractors: this.translateService.getDynamicTranslation('No of Contractors'),
            ratingPrefix: this.translateService.getDynamicTranslation('Rating'),
            consequenceRating: this.translateService.getDynamicTranslation('Consequence Rating:'),
            footer: this.translateService.getDynamicTranslation('Report generated using SEGs, Agents, and Statistics')
        });
    }

    public trackByIndex = trackByIndex;
}
